import React from 'react';
import { Outlet } from 'react-router-dom';
//test
const Auth = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Auth;
